import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";

import { FrameViews } from "@com.mgmtp.a12.client/client-core/lib/core/frame";
import { LocalizerContext } from "@com.mgmtp.a12.utils/utils-localization-react/lib/main";
import { GlobalMessageBox, StyledIconWrapper } from "@com.mgmtp.a12.widgets/widgets-core";
import { StyledGlobalMessageBoxText } from "@com.mgmtp.a12.widgets/widgets-core/lib/global-message-box/main/global-message-box.styled";

import { ApplicationBanner } from "../../component/ApplicationBanner";
import { CustomMainMenu } from "../../component/CustomMainMenu";
import { InfoHeader } from "../../component/InfoHeader";
import { UserInfoHeader } from "../../component/UserInfoHeader";
import { RESOURCE_KEYS } from "../../localization";

import { selectEnvironmentData } from "../slices/environmentData/selectors";

import HeaderItemProps = FrameViews.HeaderItemProps;

// Main Menu als funktionale Komponente
export const CustomApplicationFrameLayout: FrameViews.Layout = {
	component: function CustomApplicationFrameLayout(props: FrameViews.LayoutProps) {
		const [selectValue, setSelectValue] = React.useState("ADMIN");

		const environmentData = useSelector(selectEnvironmentData);

		const { localizer } = React.useContext(LocalizerContext);

		const MemorizedMainMenu = React.useMemo<React.ComponentType<FrameViews.MainMenuProps>>(() => {
			return function MemorizedMainMenu(props) {
				return <CustomMainMenu {...props} />;
			};
		}, []);

		const additionalHeaderItems = React.useMemo<HeaderItemProps[]>(() => {
			return [
				{
					item: <UserInfoHeader />,
					orientation: "rightSlots-left"
				},
				{
					item: <InfoHeader />,
					orientation: "rightSlots-left"
				}
			];
		}, [selectValue, setSelectValue]);

		const envName = environmentData.currentEnvName?.toLowerCase();
		return (
			<FrameViews.ApplicationFrameLayout
				{...props}
				mainMenuComponent={MemorizedMainMenu}
				logo={<ApplicationBanner interactive />}
				additionalHeaderItems={additionalHeaderItems}
				globalMessageBox={
					(envName === "stage" || envName === "preview") && (
						<StyledGlobalMessageBox
							content={localizer({ key: RESOURCE_KEYS.application.header.banner[envName] })}
						/>
					)
				}
			/>
		);
	}
};

export const StyledGlobalMessageBox = styled(GlobalMessageBox)`
	${StyledIconWrapper}, ${StyledGlobalMessageBoxText} {
		color: ${({ theme }) => theme.colors.text.color};
	}

	background-color: #ff7429;
`;
